import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submitted-page',
  templateUrl: './submitted-page.component.html',
  styleUrls: ['./submitted-page.component.scss']
})
export class SubmittedPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
